(() => {
  const form = document.getElementById('SavaProjectForm');
  if (!form) return;
  const stateKey = 'savaContactSubmissionV2';
  const state = {
    read() { try { return JSON.parse(sessionStorage.getItem(stateKey) || 'null'); } catch (_) { return null; } },
    set(value) { try { sessionStorage.setItem(stateKey, JSON.stringify(value)); } catch (_) {} },
    clear() { try { sessionStorage.removeItem(stateKey); } catch (_) {} }
  };
  const track = (name, extra) => window.SavaAttribution?.track(name, extra);
  const success = form.querySelector('[data-form-success]');
  const serverError = form.querySelector('[data-form-error]');
  const pending = state.read();
  if (success) {
    if (pending && Date.now() - pending.time < 30 * 60 * 1000) {
      state.clear();
      track('sava_form_submit_success', { event_id: pending.id });
    }
    success.focus();
    return;
  }
  if (serverError) {
    state.clear();
    track('sava_form_submit_error');
    serverError.focus();
  }
  const steps = [...form.querySelectorAll('[data-step]')];
  const next = form.querySelector('[data-next]');
  const back = form.querySelector('[data-back]');
  const submit = form.querySelector('[data-submit]');
  const message = form.querySelector('[data-validation]');
  const phone = form.querySelector('#SavaPhone');
  const method = form.querySelector('#SavaMethod');
  const progress = form.querySelector('[data-progress-text]');
  const bar = form.querySelector('[data-progress-bar]');
  const visited = new Set();
  let current = 0;
  let started = false;
  let submitting = false;
  const syncPhone = () => { phone.required = method.selectedIndex === 1; };
  method.addEventListener('change', syncPhone);
  syncPhone();
  form.noValidate = true;
  const show = (index, focus = true) => {
    current = index;
    steps.forEach((step, i) => { step.hidden = i !== index; });
    progress.textContent = `${index + 1} iš ${steps.length}`;
    bar.style.width = `${(index + 1) * 100 / steps.length}%`;
    back.hidden = index === 0;
    next.hidden = index === steps.length - 1;
    submit.hidden = index !== steps.length - 1;
    message.textContent = '';
    if (focus) {
      const heading = steps[index].querySelector('legend');
      heading.tabIndex = -1;
      heading.focus();
    }
    if (index > 0 && !visited.has(index)) {
      visited.add(index);
      track(`sava_form_step_${index + 1}`);
    }
  };
  const invalidField = index => [...steps[index].querySelectorAll('input,textarea,select')].find(field => {
    if (field.disabled || field.type === 'hidden') return false;
    if (field.required && field.type !== 'checkbox' && field.type !== 'radio' && !field.value.trim()) return true;
    return !field.checkValidity();
  });
  const validate = index => {
    const invalid = invalidField(index);
    if (!invalid) return true;
    if (current !== index) show(index, false);
    message.textContent = form.dataset.validationText;
    invalid.focus();
    invalid.reportValidity();
    return false;
  };
  next.addEventListener('click', () => {
    if (!validate(current)) return;
    if (!started) { started = true; track('sava_form_start'); }
    show(Math.min(steps.length - 1, current + 1));
  });
  back.addEventListener('click', () => show(Math.max(0, current - 1)));
  form.addEventListener('submit', event => {
    if (submitting || form.querySelector('#SavaWebsite')?.value) { event.preventDefault(); return; }
    if (current !== steps.length - 1) { event.preventDefault(); next.click(); return; }
    syncPhone();
    for (let i = 0; i < steps.length; i++) {
      if (!validate(i)) { event.preventDefault(); track('sava_form_submit_error'); return; }
    }
    window.SavaAttribution?.populate();
    state.set({ id: window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`, time: Date.now() });
    submitting = true;
    submit.disabled = true;
    setTimeout(() => { submitting = false; submit.disabled = false; }, 15000);
  });
  window.addEventListener('pageshow', () => { submitting = false; submit.disabled = false; });
  show(0, false);
})();
